import * as React from "react";
import { ApiSelectedFixedComment } from "../../../../misc/api/FixedComments/apiTypes";
import AsyncFixedCommentsButton from "../AsyncFixedComments/AsyncFixedCommentsButton";
import { useCurrentStudyConfigurationContext } from "../../../../Core/CurrentStudyConfigurationContext";
import { FixedCommentSetTypeEnum } from "../../../../misc/api/FixedComments/FixedCommentSetTypes";
import { FixedCommentEntityTypeEnum } from "../../../../misc/api/FixedComments/FixedCommentSetEntityTypes";
import { SessionTypes } from "../../../../misc/api/ApiSessionTypes";
import { AnalysisSetTestFixedComment } from "webportalclient";
import { useWebPortalApiClient } from "../../../../misc/api/WebPortalTokenClient";

interface TechnicianTestCommentsProps {
    TestId: string;
    TestNumber: number;
    AnalysisSetId: string;
    IsReadOnly?: boolean;
    SessionType: SessionTypes;
}

const TechnicianTestComments = ({ TestId, TestNumber, AnalysisSetId, IsReadOnly, SessionType }: TechnicianTestCommentsProps): JSX.Element => {
    const client = useWebPortalApiClient();
    const { study } = useCurrentStudyConfigurationContext();

    const fetchComments = async () => {

        let analysisSetTestFixedComments: AnalysisSetTestFixedComment[] = [];

        switch (SessionType) {
            case SessionTypes.Fvc:
                analysisSetTestFixedComments = (await client.client.getSpirometryAnalysisSetTests(undefined, `analysisSetId eq ${AnalysisSetId} and testId eq ${TestId}`)).value[0].fixedComments;
                break;
            case SessionTypes.Svc:
                analysisSetTestFixedComments = (await client.client.getSvcAnalysisSetTests(undefined, `analysisSetId eq ${AnalysisSetId} and testId eq ${TestId}`)).value[0].fixedComments;
                break;
        }

        const fixedCommentsResult = await client.client.getStudyFixedCommentSets(undefined, `studyId eq ${study.id} and sessionType eq '${SessionType}' and commentSetType eq '${FixedCommentSetTypeEnum.Technician}'`, undefined, `fixedCommentSets($expand=comments)`);

        const comments = fixedCommentsResult.value[0].fixedCommentSets.find(fcs => fcs.entityType === FixedCommentEntityTypeEnum.Test).comments;

        return comments.map(f => ({
            ...f,
            IsSelected: analysisSetTestFixedComments.length > 0 ? analysisSetTestFixedComments.map(ci => ci.fixedCommentId).includes(f.id) : false,
            FollowOnComment: analysisSetTestFixedComments.length > 0 ? analysisSetTestFixedComments.find(tc => tc.fixedCommentId === f.id)?.followOnComment : null,
        }));
    }

    const updateComments = async (commentMutations: ApiSelectedFixedComment[]) => {
        const analysisSetTestResult = await client.client.getSpirometryAnalysisSetTests(undefined, `testId eq ${TestId} and analysisSetId eq ${AnalysisSetId}`);

        const selectedComments = commentMutations.filter(x => x.IsSelected);

        await client.client.patchSpirometryAnalysisSetTest({
            fixedComments: selectedComments.map(cm => ({
                analysisSetTestId: analysisSetTestResult.value[0].id,
                fixedCommentId: cm.Id,
            }))
        }, analysisSetTestResult.value[0].id);
    }

    return (<AsyncFixedCommentsButton header={`Technician Fixed Comments - Test ${TestNumber}`} isReadOnly={IsReadOnly} fetchComments={fetchComments} updateComments={updateComments} buttonText={IsReadOnly ? "Show" : "Open"}  />);
};

export default TechnicianTestComments;
